module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0013.bfd194e1.jpg";